import React, { useEffect } from "react";
import { ChevronRight } from "lucide-react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Container } from "@/components/site/Primitives";

const Block = ({ block }) => {
  const t = block.text;
  if (block.tag.startsWith("h")) {
    const level = Math.min(Number(block.tag[1]) + 0, 6);
    if (level <= 2) return <h2 className="mt-12 text-[26px] font-bold leading-[1.25] text-[#1e2532]">{t}</h2>;
    return <h3 className="mt-8 text-[19px] font-semibold text-[#1e2532]">{t}</h3>;
  }
  if (block.tag === "li") return <li className="ml-5 list-disc text-[16px] leading-[1.8] text-[#565f70]">{t}</li>;
  return <p className="mt-4 text-[16px] leading-[1.8] text-[#565f70]">{t}</p>;
};

export default function LegalPage({ data }) {
  useEffect(() => {
    document.title = data.metaTitle;
    window.scrollTo(0, 0);
  }, [data]);

  return (
    <>
      <Header />
      <main data-testid="legal-main">
        <section className="bg-[#1e2532] pb-16 pt-[140px] text-white">
          <Container>
            <nav aria-label="Breadcrumb" className="mb-6 flex items-center gap-1.5 text-[13px] text-white/50">
              <a href="/" className="hover:text-white">Startseite</a>
              <ChevronRight size={13} />
              <span className="text-white/80">{data.h1}</span>
            </nav>
            <h1 className="font-bold" data-testid="legal-h1">{data.h1}</h1>
          </Container>
        </section>
        <section className="section-pad bg-white">
          <Container className="max-w-[880px]">
            {data.blocks.map((b, i) => (
              <Block key={i} block={b} />
            ))}
          </Container>
        </section>
      </main>
      <Footer />
    </>
  );
}
